import permitirVendaSemEstoque from "./permitirVendaSemEstoque"
import retornarQtdCompradaItem from "./retornarQtdCompradaItem"

export default (codigo, saldo, edicao, sku, quantidade = 0) => {
    let qtd = !edicao? retornarQtdCompradaItem(codigo, sku) : quantidade - 1 

    if (permitirVendaSemEstoque()) return false

    if (!permitirVendaSemEstoque() && (!(saldo > 0) || qtd >= saldo)) return true

    return false
}